import React, { useEffect, useState } from "react";
import { HTTP } from "../../../api/resources";
import Select from "react-select";

export default function PageMemberships({groupId, allData, projects, members}) {
    const [editing, setEditing] = useState(false)
    const [showing, setShowing] = useState(false)
    const [saving, setSaving] = useState(false)
    const [showMessage, setShowMessage] = useState('Show Memberships')
    const [selectedMember, setSelectedMember] = useState(null)
    const [selectOptions, setSelectOptions] = useState([])
    const [editMembers, setEditMembers] = useState([])

    // rerender based on certain value changes
    useEffect(() => {
        decideShowMessage()
    }, [showing, editMembers, selectOptions])

    // one time render use effect
    useEffect(() => {
        let data = initializeEditMembers()
        initializeSelectOptions(data)
    }, [])

    // set the edit members with previous data
    const initializeEditMembers = () => {
        let data = []

        if (projects && projects.length > 0) {
            let projectsData = allData.filter(data => data.type == 'project')
            let matchedData = projectsData.filter(data =>
                projects.find(project => project.id === data.real_id)
            )
            data = data.concat(matchedData)
        }

        if (members && members.length > 0) {
            let membersData = allData.filter(data => data.type == 'user')
            let matchedData = membersData.filter(data =>
                members.find(member => member.id === data.real_id)
            )
            data = data.concat(matchedData)
        }

        setEditMembers(data)
        return data
    }

    // set the options available for selection
    const initializeSelectOptions = (data = null) => {
        let array = []
        let projectArray = []
        let userArray = []

        if (data && data.length > 0) {
            let combinedArray = allData.filter(d =>
                !data.some(i => i.id == d.id && i.type == d.type)
            )
            array = combinedArray
        } else {
            array = allData
        }

        projectArray = array.filter(arr => arr.type == 'project')
        userArray = array.filter(arr => arr.type == 'user')

        userArray = _.orderBy(userArray, ['name'], ['asc'])
        projectArray = _.orderBy(projectArray, ['name'], ['asc'])
        array = [...projectArray, ...userArray]

        setSelectOptions(array)
    }

    // handle closing of the component
    const handleClose = () => {
        let updatedMembers = []

        if (editMembers && editMembers.length > 0) {
            let removeMembers = editMembers.filter(member => member.not_saved && member.not_saved == true)
            if (removeMembers && removeMembers.length > 0) {
                updatedMembers = editMembers.filter(member => !member.not_saved || member.not_saved == false)
                Alert.show('notice', 'Removed unsaved changes')
                setEditMembers(updatedMembers)
                initializeSelectOptions(updatedMembers)
            }
        }
        setEditing(false)
        setShowing(false)
    }

    const refreshMemberships = () => {
      let memberships = []

      editMembers.map(member => {
        let newMember = member
        newMember.not_saved = false
        memberships.push(newMember)
      })

      setEditMembers(memberships)
    }

    // handle the submition of data
    const handleSubmit = () => {
        if (!editMembers || editMembers.length < 1) return
        setSaving(true);
        let unsaved = editMembers.filter(member => member.not_saved == true)
        let data = {memberships: unsaved}

        HTTP.patch(`/group/mass/add/${groupId}`, data).then(response => {
            Alert.show("notice", "Updated successfully");
            setSaving(false)
            refreshMemberships()
        }).catch(e => {
            Alert.show("error", "Could not update, try again");
            setSaving(false);
        })
    }

    // add members to the list
    const addMember = () => {
        if (!selectedMember) return

        // prepare the members data
        selectedMember.not_saved = true
        setEditMembers([...editMembers, selectedMember])

        // remove from options
        let updatedMembers = selectOptions.filter(option => option.id !== selectedMember.id)
        setSelectOptions(updatedMembers)
        setSelectedMember(null)
    }

    // remove members from the list
    const removeMember = (member) => {
        if (!member.not_saved) {
            if (member.type == 'project') removeProject(member)
            if (member.type == 'user') removeUser(member)
        }
        let updatedMembers = editMembers.filter(m => m.id !== member.id)
        setEditMembers(updatedMembers)
        Alert.show('notice', 'Removed successfully')
        initializeSelectOptions(updatedMembers)
        setTotalSelection(editMembers)
    }

    // remove user
    const removeUser = async (user) => {
        setSaving(true)
        HTTP.delete(`/group/membership/delete/${user.real_id}/${groupId}/user`).then(response => {
          setSaving(false);
        }).catch(e => {
          setSaving(false);
          Alert.show('error', 'member not removed! Try again or refresh.');
        })
      }

    // remove group
    const removeProject = async (project) => {
        setSaving(true)
        HTTP.delete(`/group/membership/delete/${project.real_id}/${groupId}/project`).then(response => {
          setSaving(false);
        }).catch(e => {
          setSaving(false);
          Alert.show('error', 'Could not be removed! Try again or refresh.');
        })
      }

    // decide what the show message displays
    const decideShowMessage = () => {
        if (showing) setShowMessage('Hide Memberships')
        if (!showing) setShowMessage('Show Memberships')
    }

    const getAmount = () => {
        if (editMembers.length < 5) return editMembers.length
        if (editMembers.length >= 5) return 5
    }

    const determineRoute = (member) => {
      if (member.type == 'user') return `/b/${member.real_id}`
      if (member.type == 'project') return `/pro/${member.real_id}`
    }

    useEffect(() => {})


  return(
    <div id="user-group-form" className="card">
        <div className="card-header flex-header">
            <div>
                <h4 className="card-title">Memberships</h4>
                {showing && <small>Showing all {editMembers.length} memberships</small>}
                {!showing && !editing && <small>Showing {getAmount()} of {editMembers.length}</small>}
            </div>
        <div>
          {editing && (
            <div>
              <button onClick={handleClose} name="button" className="btn btn-outline-danger mr-1">
                Close
              </button>
              <button onClick={handleSubmit} name="button" className="btn btn-primary">
                {saving && (<i className="fa fa-spinner-third fa-spin mr-2"></i>)}
                Save
              </button>
            </div>
          )}

          {!editing &&
            <button onClick={() => setShowing(!showing)} className="btn btn-primary mr-1">
                 { showMessage }
            </button>
          }

          {!editing && (
            <button onClick={() => setEditing(true)} className="btn btn-primary"> Edit Memberships</button>
          )}
        </div>
      </div>

      {editing && (
        <div className="form-group">
          <label>Add Members</label>
          <div className="input-group">
            <Select
              className="form-control select-Members"
              classNamePrefix="select-Members"
              onChange={(member) =>
                setSelectedMember(member)
              }
              options={selectOptions}
              getOptionLabel={member => `${member.name}` }
              getOptionValue={member => member.id}
              value={selectedMember}
            />
            <div className="input-group-append">
              <button onClick={() => addMember()} className="btn btn-primary">Add</button>
            </div>
          </div>
        </div>
      )}

    <div className="list-group list-group-flush">
        {(editing || showing) && editMembers.map((member) => (
          <div key={member.id} id={`group-table-${member.id}`} className="list-group-item">
            <div className='list-group-item-body'>
              <div className='list-group-item-body-main mb-2'>
                <span className="mr-1">{member.name}</span>
                <a
                  href={
                    determineRoute(member)
                  }
                  target="_blank"
                  rel="noreferrer"
                ></a>
              </div>
            </div>
            {editing && (<div className='list-group-item-actions d-none-mobile'>
              { member.not_saved && (<span className="badge badge-sm badge-warning badge-pill mr-2">Not Saved</span>)}

              <button
                onClick={() => removeMember(member)}
                className="btn btn-sm btn-danger">Remove</button>
            </div>
            )}

          </div>)
        )}

        {!editing && !showing && editMembers.slice(0, 5).map((member) => (
          <div key={member.id} id={`group-table-${member.id}`} className="list-group-item">
            <div className='list-group-item-body'>
              <div className='list-group-item-body-main mb-2'>
                <span className="mr-1">{member.name}</span>
                <a
                  href={
                    determineRoute(member)
                  }
                  target="_blank"
                  rel="noreferrer"
                ></a>
              </div>
            </div>
            {editing && (<div className='list-group-item-actions d-none-mobile'>
              { member.not_saved && (<span className="badge badge-sm badge-warning badge-pill mr-2">Not Saved</span>)}

              <button
                onClick={() => removeMember(member)}
                className="btn btn-sm btn-danger">Remove</button>
            </div>
            )}

          </div>)
        )}
      </div>
    </div>
  );
}
